/** 内置模型条目（仅供参考；实际可调用的模型取决于当前配置的 LLM 供应商与 API）。 */
export interface AiBuiltinModelDef {
  /** 发往 /ai/chat/messages/stream 的 model 字段 */
  apiId: string
  /** 下拉中展示的名称 */
  label: string
  beta?: boolean
  /** 是否展示为「在线」绿点（仅 UI 提示） */
  online?: boolean
}

export const AI_BUILTIN_MODELS: AiBuiltinModelDef[] = [
  { apiId: 'deepseek-v4-flash', label: 'DeepSeek-V4-Flash', online: true },
  { apiId: 'glm-5.3-flash', label: 'GLM-5.3-Flash', online: true }
]
